<template>
    <div class="video-player">
        <video preload playsinline :poster="poster" ref="video" :muted="autoplay ? true : null" :loop="loop ? true : null" :disableremoteplayback="autoplay ? true : null" x-webkit-airplay="deny" :controls="controls ? true : null">
            <source :src="src" type="video/mp4">
        </video>
        <button class="icon" @click.prevent="play" ref="button" v-if="!autoplay">
            <inline-svg src="/images/svg/play.svg" title="play"/>
        </button>
    </div>
</template>
<script setup>
import { ref, onMounted } from 'vue';
import { useIntersectionObserver } from '@vueuse/core'
import InlineSvg from 'vue-inline-svg';

const props = defineProps({
    src:String,
    poster:String,
    autoplay:Boolean,
    loop:Boolean,
    controls:Boolean,
    rounded:Boolean
});

const video = ref(null);
const button = ref(null);

let status = {
    greatest_marker:0,
    _progress_markers: {
        25:false,
        50:false,
        75:false
    },
    current:0
};

function eventHandler(e){
    switch(e.type) {
        case 'timeupdate':
            // Let's set the save the current player's video time in our status object
            status.current = Math.round(e.target.currentTime);
            // We just want to send the percent events once
            var pct = Math.floor(100 * status.current / e.target.duration);
            for (var j in status._progress_markers) {
                if (pct >= j && j > status.greatest_marker) {
                    status.greatest_marker = j;
                }
            }
            // current bucket hasn't been already sent to GA?, let's push it to GTM
            if (status.greatest_marker && !status._progress_markers[status.greatest_marker]) {
                status._progress_markers[status.greatest_marker] = true;
                window.gtag('event', 'video_progress', {
                    'video_url':window.location.href,
                    'video_duration':e.target.duration,
                    'video_current_time':e.target.currentTime,
                    'video_title':decodeURIComponent(e.target.currentSrc.split('/')[e.target.currentSrc.split('/').length - 1]),
                    'video_percent':status.greatest_marker
                });
            }
            break;
            // This event is fired when user's click on the play button
        case 'play':
            window.gtag('event', 'video_start', {
                'video_url':window.location.href,
                'video_duration':e.target.duration,
                'video_current_time':e.target.currentTime,
                'video_title':decodeURIComponent(e.target.currentSrc.split('/')[e.target.currentSrc.split('/').length - 1]),
                'video_percent':status.greatest_marker
            });
            break;
        case 'ended':
            window.gtag('event', 'video_complete', {
                'video_url':window.location.href,
                'video_duration':e.target.duration,
                'video_current_time':e.target.currentTime,
                'video_title':decodeURIComponent(e.target.currentSrc.split('/')[e.target.currentSrc.split('/').length - 1]),
                'video_percent':'100'
            });
            break;
        default:
            break;
    }
}

const play = ()=>{
    button.value.style.display = 'none';
    video.value.controls = true;
    video.value.play();
    video.value.style.objectFit = 'contain';
}

onMounted(()=>{
    if(props.autoplay){
        useIntersectionObserver(video, ([{isIntersecting}], observerElement) => {
            if(isIntersecting){
                video.value.play();
            } else {
                video.value.pause();
            }
        });
    } else {
        video.value.addEventListener('play', eventHandler, false);
        video.value.addEventListener('timeupdate', eventHandler, false);
        video.value.addEventListener('ended', eventHandler, false);
    }
})
</script>
